import { render, staticRenderFns } from "./modalEditarContacto.vue?vue&type=template&id=c52a7f48"
import script from "./modalEditarContacto.vue?vue&type=script&lang=js"
export * from "./modalEditarContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports